import { PluginEvent, PluginEventType } from 'roosterjs-editor-types';

export default function linkPluginTrigger(evt: PluginEvent) {
    return (
        evt.eventType === PluginEventType.ContentChanged ||
        evt.eventType === PluginEventType.ExtractContent ||
        evt.eventType === PluginEventType.KeyDown ||
        evt.eventType === PluginEventType.KeyPress
    );
}
